import { Text } from '@/components/atoms/Text';
import { Tooltip } from '@/components/atoms/Tooltip/Tooltip';
import toolTipIconSrc from '~/icons/tooltip_icon.svg';
import { SvgIcon } from '@/components/SvgIcon';

export const SectionHeader = ({
  title,
  tooltip,
}: {
  title?: string;
  tooltip?: React.ReactNode;
}) => (
  <div className='text-body-m-medium flex items-center gap-1 bg-gray-50 py-2 pl-2 text-gray-500'>
    <Text className='text-gray-500'>{title}</Text>
    {!!tooltip && (
      <Tooltip
        text={tooltip}
        classNames={{ text: 'max-w-52' }}
        flowDirection='bottom-center'
      >
        <SvgIcon src={toolTipIconSrc} className='text-brand-500 ml-1 inline h-6 w-6' />
      </Tooltip>
    )}
  </div>
);
